import { useQuery } from 'react-query';

import { TAG_API_ROUTES } from '@/api-routes';
import { axiosInstance } from '@/axios';
import {
  NEEDL_BOOKMARK_TAG,
  ONE_MINUTE,
  QUERY_KEY,
} from '@/components/UserTags/common';

type UserTagsResponse = { results: string[] };

export const useUserTags = () => {
  return useQuery(
    [QUERY_KEY, 'user-tags'],
    ({ signal }) =>
      axiosInstance.get<UserTagsResponse>(TAG_API_ROUTES.userTags(), {
        signal,
      }),
    {
      select: (data) => {
        const tags = data.data.results ?? [];
        return {
          tags,
          userTags: tags.filter((tag) => tag !== NEEDL_BOOKMARK_TAG),
        };
      },
      staleTime: ONE_MINUTE,
    }
  );
};
